// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dc25e56f","484":"b0fb036c","503":"1e4fd138","844":"ed62c4ca"}[chunkId] + ".chunk.js";
};